module.exports = __webpack_public_path__ + "img/en.3d9ba8a1.svg";